import { Box, Typography, IconButton, useTheme, CircularProgress } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState, useEffect } from 'react';
import { useMetrics } from '../../../shared/context/metricsContext';

export default function SelectedLocation({ otMetricsByLocation }) {

    const theme = useTheme();
    const { rootLocations, loadingRootLocations, getRootLocations, currentLocation, currentLocationIndex, setCurrentLocation, setCurrentLocationIndex } = useMetrics();

    useEffect(() => {
        getRootLocations();
    }, []);

    useEffect(() => {
        if (rootLocations.length > 0) {
            setCurrentLocation(rootLocations[currentLocationIndex]);
        }
    }, [rootLocations]);

    const handlePrevious = () => {
        if (currentLocationIndex > 0) {
            setCurrentLocationIndex(currentLocationIndex - 1);
            setCurrentLocation(rootLocations[currentLocationIndex - 1]);
        }
    }

    const handleNext = () => {
        if (currentLocationIndex < rootLocations.length - 1) {
            setCurrentLocationIndex(currentLocationIndex + 1);
            setCurrentLocation(rootLocations[currentLocationIndex + 1]);
        }
    }

    if (loadingRootLocations) return <CircularProgress />

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        fontSize: "18px",
                        color: theme.palette.text.primary,
                    }}>{currentLocation?.name}</Typography>


                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <IconButton 
                                onClick={handlePrevious}
                                size="small"
                                sx={{ 
                                    backgroundColor: theme.palette.background.paper,
                                    boxShadow: theme.palette.shadow.default,
                                    '&:hover': {
                                        backgroundColor: theme.palette.background.default
                                    }
                                }}
                            >
                                <ChevronLeftIcon />
                            </IconButton>
                            <Typography variant="body2" sx={{ mx: 1 }}>
                                {currentLocationIndex + 1} / {rootLocations.length}
                            </Typography>
                            <IconButton 
                                onClick={handleNext}
                                size="small"
                                sx={{ 
                                    backgroundColor: theme.palette.background.paper,
                                    boxShadow: theme.palette.shadow.default,
                                    '&:hover': {
                                        backgroundColor: theme.palette.background.default
                                    }
                                }}
                            >
                                <ChevronRightIcon />
                            </IconButton>
                        </Box>
      
                </Box>
    )
}